"use strict"
import service from "./request"
import bus from "./bus.js"
import store from "@/store"
import { refreshToken } from 'api/api.js'
import { getTokenInfo,getRefreshToken } from "@/utils/auth"
import router from '@/router'

// 请求参数
function getOptions(url, method, data, params, queryAndBody,otherApi,isFormData) {
  const options = {
    method: method,
    baseURL: otherApi ? otherApi:window.g.API_ROOT,//_url
    url: url,
    timeout: 10*60*1000,
    headers: {}
  };
  if (!!queryAndBody) {
    const paramsData = data;
    const bodyObject = paramsData.bodyObject;
    delete paramsData.bodyObject;
    // options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    options.params = paramsData;
    options.data = bodyObject;
    if(isFormData){
        let formData = new FormData()
        for (const key of Object.keys(bodyObject)) {
            formData.append(key, bodyObject[key]);
        }
        options.data = formData;
    }
  } else {
    const pd = !params ? "data" : "params";
    options[pd] = data;
  }

  return options;
}

async function checkStatus(response) {
  //处理响应数据
  if (response && response.status === 200) {
    // loading,如果http状态码正常，则直接返回数据
    let res = response.data;
    if (!res) {
      bus.$message.error("服务器开了个小差");
      return false;
    }
    if (res.code == 10000 || res.Code == 10000 || res.code == 200 || res.status == 'success' || res.flag == 'Success') {
        return res;
    } else if (res.code === 10001 && (res.message === '当前用户为超级管理员,默认拥有所有数据权限' || res.message === '该用户未配置医院数据查询权限,请联系管理员')) {
        bus.$message.error(res.message);
      return res
    }else if(res.userCode){
        return res
    }else if(res.code === 10050){//令牌过期
        store.dispatch('user/logout')
        router.push('/login')
        bus.$message.error(res.message);
        return false
    }else {
      if (res.message === '该疫情报告不存在') {
        bus.$message.error('未匹配到患者');
      } else if (res.Message) {
        bus.$message.error(res.Message);
      } else if(res.message === '存在错误数据'){
        let resLen = res.content.list.length
        let notify = ''
        for(let i = 0; i < resLen; i++){
          if(res.content.list[i].resultMessage){
            if(i === 0){
              notify = res.content.list[i].resultMessage
            } else {
              notify = notify + '<br/>' + res.content.list[i].resultMessage
            }
          }
        }
        bus.$notify({
          title: '提示',
          dangerouslyUseHTMLString: true,
          message: notify
        });
      }else if(res.message === '未登录'){
        return res;
      }else if(res.message === '二维码已过期，请刷新'){
        bus.$message.error(res.message);
        return res;
      }else if(res.message === '用户未授权'){
        return res
      }else if (res.message && res.message !== '该模板组不存在') {
        bus.$message.error(res.message);
      }
      return false;
    }
  }else if(response && response.status === 401 && response.status === 403){//过期退出
    store.dispatch('user/logout')
    router.push('/login')

    if (response &&response.data.Message) {
        bus.$message.error(response.data.Message);
      } else if (response && response.data.message) {
        bus.$message.error(response.data.message);
      }

    return false
  } else {
    if (response &&response.data.Message) {
      bus.$message.error(response.data.Message);
    } else if (response && response.data.message) {
      bus.$message.error(response.data.message);
    }
    return false;
  }
}

function checkCode(error) {
    console.log('error',error)
    bus.$message.error("网络异常~");
}

// 令牌时间过期后的刷新令牌方法
export function postRefreshToken() {
  // 如果有这个字段 去刷新token
  let tokenInfo = getTokenInfo()
  let token = tokenInfo ? tokenInfo.accessToken : ''
  let refreshTokenStr = getRefreshToken() // 刷新令牌
  return new Promise(async (resolve) => {
    if (!token || !refreshTokenStr) {
      // 如果token不存在
      resolve(false)
    } else {
      let data = {
        accessToken: token,
        refreshToken: refreshTokenStr
      }
      await refreshToken(data).then(async (res) => {
        if (res) {
          const cont = res.content
          await store.dispatch('user/setNewTokenInfo', cont)
          // 重新调用接口
          resolve(true)
        } else {
          resolve(false)
        }
      }).catch(error => {
        resolve(false)
      })
    }
  })
}

export default {
  async post(url, data, query, queryAndBody,otherApi) {
    const options = getOptions(url, "post", data, query, queryAndBody,otherApi);
    return service(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  async postFormData(url, data, query, queryAndBody,otherApi) {
    const options = getOptions(url, "post", data, query, queryAndBody,otherApi,true);
    return service(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  async get(url, data, query,otherApi) {
    const options = getOptions(url, "get", data, query,'',otherApi);
    return service(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  async put(url, data, query, queryAndBody,otherApi) {
    const options = getOptions(url, "put", data, query, queryAndBody,otherApi);
    return service(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  },
  async patch(url, data, query) {
  const options = getOptions(url, "patch", data, query);
  return service(options)
    .then(response => {
      return checkStatus(response);
    })
    .catch(res => {
      return checkCode(res);
  });
},
  async delete(url, data,otherApi) {
    const options = getOptions(url, "delete", data, "query",'',otherApi);
    return service(options)
      .then(response => {
        return checkStatus(response);
      })
      .catch(res => {
        return checkCode(res);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/http.js